import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidescrollingLogosPanelComponent } from './sidescrolling-logos-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AutoscrollImageCarouselComponent } from 'src/app/shared/components/autoscroll-image-carousel/autoscroll-image-carousel.component';

@NgModule({
  declarations: [SidescrollingLogosPanelComponent, AutoscrollImageCarouselComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [SidescrollingLogosPanelComponent, AutoscrollImageCarouselComponent],})
export class SidescrollingLogosPanelModule { }
